import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "geo-multi-method-page" }
const _hoisted_2 = { class: "geo-multi-method-page__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_GeoMultiMethodPageHeader = _resolveComponent("GeoMultiMethodPageHeader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_MainSettings = _resolveComponent("MainSettings")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_PaymentMethodsSettings = _resolveComponent("PaymentMethodsSettings")!
  const _component_AddMethodsDialog = _resolveComponent("AddMethodsDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_GeoMultiMethodPageHeader, {
        "is-show-back-button": true,
        onBackButtonPressed: _ctx.openGeoPaymentList
      }, {
        "title-content": _withCtx(() => [
          _createElementVNode("h2", null, "Multi-method for " + _toDisplayString(_ctx.multiMethodCountry), 1 /* TEXT */),
          _createVNode(_component_el_tag, {
            type: _ctx.geoMultiMethod.enabled ? _ctx.TagComponentTypes.SUCCESS : _ctx.TagComponentTypes.WARNING
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.geoMultiMethod.enabled ? 'Method enabled' : 'Method disabled'), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onBackButtonPressed"]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_el_container, { class: "geo-multi-method-page__content-block" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { class: "geo-multi-method-page__content-block-header" }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Main settings", -1 /* CACHED */)),
                _createVNode(_component_el_tooltip, {
                  content: "Please save main settings first",
                  disabled: !_ctx.isUnsavedChanges
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: _ctx.geoMultiMethod.enabled ? _ctx.TagComponentTypes.WARNING : _ctx.TagComponentTypes.PRIMARY,
                      disabled: _ctx.isUnsavedChanges || !_ctx.geoMultiMethod.multiMethodId,
                      onClick: _ctx.updateGeoMultiPaymentMethodEnabledState
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.geoMultiMethod.enabled ? 'Disable' : 'Enable') + " method ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["type", "disabled", "onClick"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_main, { class: "geo-multi-method-page__content-block-body" }, {
              default: _withCtx(() => [
                _createVNode(_component_MainSettings, {
                  "is-save-action-disabled": _ctx.isSaveActionDisabled,
                  onSaveAction: _ctx.saveGeoMultiMethodMainSettings
                }, null, 8 /* PROPS */, ["is-save-action-disabled", "onSaveAction"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_container, { class: "geo-multi-method-page__content-block" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { class: "geo-multi-method-page__content-block-header" }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Payment methods", -1 /* CACHED */)),
                _createVNode(_component_el_tooltip, {
                  disabled: !!_ctx.geoMultiMethod.multiMethodId,
                  content: "Please save main settings first"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: _ctx.TagComponentTypes.PRIMARY,
                      disabled: !_ctx.geoMultiMethod.multiMethodId,
                      onClick: _ctx.openMethodsAssociatingDialog
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Add payment method ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["type", "disabled", "onClick"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_main, { class: "geo-multi-method-page__content-block-body" }, {
              default: _withCtx(() => [
                _createVNode(_component_PaymentMethodsSettings, {
                  "multi-method-id": _ctx.geoMultiMethod.multiMethodId
                }, null, 8 /* PROPS */, ["multi-method-id"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])), [
        [_directive_loading, _ctx.isGeoMultiMethodLoading]
      ])
    ]),
    _createVNode(_component_AddMethodsDialog)
  ], 64 /* STABLE_FRAGMENT */))
}